var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-[400px] max-h-[400px] overflow-hidden",on:{"click":_vm.emitClick}},[_c('img',{staticClass:"w-full h-full",attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }